import type { Menu } from '#/global'

const menus: Menu.recordRaw[] = [
  {
    meta: {
      title: '影片分组',
      icon: 'heroicons-solid:menu-alt-3',
    },
    path: '/coupon/movie_group/list',
  },
  {
    meta: {
      title: '系统票券',
      icon: 'heroicons-solid:menu-alt-3',
    },
    path: '/coupon/system/list',
  },
  {
    meta: {
      title: '平台票券',
      icon: 'heroicons-solid:menu-alt-3',
    },
    path: '/coupon/apply/list',
  },
]

export default menus
